import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { Observable } from 'rxjs';
import { SdkIndexService } from 'app/services/sdk-index.service';
import { SdkInsightStateService } from 'app/states/sdk-insight-state.service';
import { SdkInsight } from 'app/models/SdkInsight';

@Component({
  selector: 'app-side-insight',
  templateUrl: './side-insight.component.html',
  styleUrls: ['./side-insight.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideInsightComponent implements OnInit, OnChanges {
  @Input() selectedSdk: any;
  @Input() selectedDate = '';
  @Input() navigateTo = 'overview';

  @Output() navCloseClick: EventEmitter<Event> = new EventEmitter();

  @HostBinding('class.open') @Input() showInsight: boolean;

  tablet$: Observable<boolean>;

  data: any;
  loadingData = false;
  showNoDataFound = false;

  constructor(
    private _sdkInsightStateService: SdkInsightStateService,
    private mediaQuery: MediaQueryService,
    private element: ElementRef,
    private _sdkIndexService: SdkIndexService,
    private _changeDetector: ChangeDetectorRef
  ) {
    this.tablet$ = this.mediaQuery.lt(Breakpoint.lg);
    this._onModalClick = this._onModalClick.bind(this);
  }

  ngOnInit(): void {
    this._sdkInsightStateService.sdk$.subscribe(data => {
      this.data = data;
      this.showNoDataFound = !data?.overview?.parentCompany;
      this._changeDetector.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.showInsight) {
      if (changes.showInsight.currentValue) {
        this.element.nativeElement.addEventListener(
          'click',
          this._onModalClick
        );
      } else {
        this.element.nativeElement.removeEventListener(
          'click',
          this._onModalClick
        );
      }
    }

    if (changes.selectedSdk && changes.selectedSdk.currentValue) {
      this.getSdkInsightData();
    }

    if (changes.navigateTo && changes.navigateTo.currentValue) {
      this.scrollToSection(changes.navigateTo.currentValue);
    }
  }

  private getSdkInsightData() {
    this.loadingData = true;
    void this._sdkIndexService
      .getSdkInsightData(
        this.selectedSdk.sdkId,
        this.selectedSdk.appStore,
        this.selectedDate
      )
      .then((response: SdkInsight) => {
        this.loadingData = false;
        this._sdkInsightStateService.setSdkInsight({
          ...this.selectedSdk,
          ...response
        });
      });
  }

  private _onModalClick(evt) {
    const modal = document.querySelector('#sideInsightContent');
    const clickInside = modal.contains(evt.target);

    if (clickInside) {
      return;
    }

    this.navCloseClick.emit(evt);
    evt.preventDefault();
  }

  private scrollToSection(key: string, behavior: ScrollBehavior = 'smooth') {
    const intervalId = setInterval(() => {
      const matchingSectionEl = document.getElementById(key);
      if (matchingSectionEl) {
        clearInterval(intervalId);
        matchingSectionEl.scrollIntoView({ behavior });
      }
    }, 100);

    setTimeout(() => {
      clearInterval(intervalId);
    }, 3000);
  }

  @HostListener('window:keydown.escape', ['$event'])
  closeButtonClick(evt: KeyboardEvent) {
    this.navCloseClick.emit(evt);
  }
}
